/*
 * 权限处理
 */

/*
    新版角色code:
        0: {id: 1, name: "基础用户", code: "base_user"}
        1: {id: 2, name: "管理员", code: "manager"}
        2: {id: 3, name: "商务经理", code: "business_manager"}
        3: {id: 4, name: "工程主管", code: "engineering_supervisor"}
        4: {id: 5, name: "维保主管", code: "maintenance_supervisor"}
        5: {id: 6, name: "项目人员", code: "maintain_staff"}
        6: {id: 7, name: "消息后台管理员", code: "notify_admin"}
        7: {id: 8, name: "公司资料员", code: "info_manager"}
        8: {id: 9, name: "项目检查员", code: "project_inspector"}
        9: {id: 10, name: "公司经理", code: "company_manager"}
        10: {id: 11, name: "项目经理", code: "project_manager"}
        11: {id: 12, name: "副经理", code: "vice_manager"}
        12: {id: 13, name: "安全员", code: "security_officer"}
        13: {id: 14, name: "质检员", code: "quality_inspector"}
        14: {id: 15, name: "施工员", code: "construction_crew"}
        15: {id: 16, name: "材料员", code: "material_handler"}
        16: {id: 17, name: "资料员", code: "data_clerk"}
        17: {id: 18, name: "运营专员", code: "operation_specialist"}
        18: {id: 19, name: "项目经理(维保)", code: "weibao_project_manager"}
        19: {id: 20, name: "维保技术员", code: "weibao_technician"}
*/


import store from 'store'

// 权限判断
/**
 * @param {*} acls : 权限类型
 * @param {*} hasProjectAcl : 是否存在动态项目权限
 */
export function checkAcls(acls = {}, hasProjectAcl = false) {
    // return true
    if (hasProjectAcl && checkProjectAcls(acls)) {
        return true
    }
    let pms = store.state['user'].permission
    if (!pms) return false

    if (pms[acls.type] && pms[acls.type][acls.action]) {
        return true
    }
    return false
    // return true
}

// 动态项目权限判断
export function checkProjectAcls(acls = {}) {
    // let pms = this.getProjectAcls()
    let pms = localStorage.getItem('projectAcls') ? JSON.parse(localStorage.getItem('projectAcls')) : null
    if (!pms) return false

    if (pms[acls.type] && pms[acls.type][acls.action]) {
        return true
    }

    return false
}

// 角色判断
export function checkRole(role = []) {
    let allRole = store.state['user'].roles
    if (!allRole || allRole.length === 0) return false
    for (let i = 0; i < role.length; i++) {
        for (let j = 0; j < allRole.length; j++) {
            if (allRole[j].code === role[i]) {
                return true
            }
        }
    }
    return false
}

export function routerCheck(name, callback) {

}



// WEBPACK FOOTER //
// ./src/common/acl/index.js